export function getEditPassword() {
  return sessionStorage.getItem('editPassword') || '';
}

export function setEditPassword(pwd) {
  sessionStorage.setItem('editPassword', pwd);
}

export function clearEditPassword() {
  sessionStorage.removeItem('editPassword');
}

export function authHeaders() {
  return {
    'Content-Type': 'application/json',
    'X-Edit-Password': getEditPassword(),
  };
}
